module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "41",
      "height": "41",
      "viewBox": "0 0 41 41",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "20.5",
      "cy": "20.5",
      "r": "20.5",
      "fill": "#E8E7E5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M30.5 28.5L9.5 28H8.46L8 24.7812L9.84 22.4375L10.5 20L8.5 18V14H31V18.6875C31 19.0625 30.08 19.4688 29.62 19.625C29.4667 20.25 29.868 21.125 29.5 21.5C29.132 21.875 29.54 22.1875 30 22.5L31 24.3125V28.5H30.5Z",
      "fill": "white"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M31.2771 18.8677C31.7018 18.711 32 18.3277 32 17.8749V14.0435C32 13.4672 31.5328 13 30.9565 13H9.04348C8.46722 13 8 13.4672 8 14.0435V17.8749C8 18.3277 8.29817 18.711 8.72287 18.8677C9.51957 19.1615 10.087 19.9271 10.087 20.8261C10.087 21.725 9.51957 22.4907 8.72287 22.7844C8.29817 22.9412 8 23.3244 8 23.7773V27.6087C8 28.185 8.46722 28.6522 9.04348 28.6522H30.9565C31.5328 28.6522 32 28.185 32 27.6087V23.7773C32 23.3244 31.7018 22.9412 31.2771 22.7844C30.4807 22.4907 29.913 21.725 29.913 20.8261C29.913 19.9271 30.4807 19.1615 31.2771 18.8677ZM30.9158 23.7635C30.9372 23.7713 30.9505 23.7815 30.9565 23.788V27.6087H9.04348V23.788C9.04974 23.7817 9.06278 23.7716 9.08417 23.7635C10.3082 23.3119 11.1304 22.1315 11.1304 20.8261C11.1304 19.5207 10.3082 18.3403 9.08417 17.8887C9.06278 17.8809 9.04974 17.8704 9.04348 17.8642V14.0435H30.9565V17.8642C30.9503 17.8704 30.9372 17.8806 30.9158 17.8887C29.6918 18.3403 28.8696 19.5207 28.8696 20.8261C28.8696 22.1315 29.6918 23.3119 30.9158 23.7635Z",
      "fill": "black"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M27.5654 17.6953H19.2175C18.9293 17.6953 18.6958 17.9288 18.6958 18.2171C18.6958 18.5053 18.9293 18.7388 19.2175 18.7388H27.5654C27.8536 18.7388 28.0871 18.5053 28.0871 18.2171C28.0871 17.9288 27.8536 17.6953 27.5654 17.6953Z",
      "fill": "black"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M19.2175 21.3482H23.3915C23.6797 21.3482 23.9132 21.1147 23.9132 20.8264C23.9132 20.5382 23.6797 20.3047 23.3915 20.3047H19.2175C18.9293 20.3047 18.6958 20.5382 18.6958 20.8264C18.6958 21.1147 18.9293 21.3482 19.2175 21.3482Z",
      "fill": "black"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M25.4784 22.9131H19.2175C18.9293 22.9131 18.6958 23.1466 18.6958 23.4348C18.6958 23.7231 18.9293 23.9566 19.2175 23.9566H25.4784C25.7667 23.9566 26.0001 23.7231 26.0001 23.4348C26.0001 23.1466 25.7667 22.9131 25.4784 22.9131Z",
      "fill": "black"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M15.9303 20.3039H14.1564C13.7105 20.3039 13.3477 19.9411 13.3477 19.4952C13.3477 19.0494 13.7105 18.6865 14.1564 18.6865H16.8172C17.1052 18.6865 17.339 18.4528 17.339 18.1648C17.339 17.8768 17.1052 17.6431 16.8172 17.6431H15.5651V16.3909C15.5651 16.1029 15.3313 15.8691 15.0433 15.8691C14.7553 15.8691 14.5216 16.1029 14.5216 16.3909V17.6431H14.1564C13.1351 17.6431 12.3042 18.4739 12.3042 19.4952C12.3042 20.5165 13.1351 21.3474 14.1564 21.3474H15.9303C16.3761 21.3474 16.739 21.7103 16.739 22.1561C16.739 22.6022 16.3761 22.9651 15.9303 22.9651H13.2694C12.9814 22.9651 12.7477 23.1988 12.7477 23.4868C12.7477 23.7748 12.9814 24.0085 13.2694 24.0085H14.5216V25.2604C14.5216 25.5484 14.7553 25.7822 15.0433 25.7822C15.3313 25.7822 15.5651 25.5484 15.5651 25.2604V24.0083H15.9303C16.9516 24.0083 17.7825 23.1771 17.7825 22.1558C17.7825 21.1348 16.9516 20.3039 15.9303 20.3039Z",
      "fill": "black"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ef6c923","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/progressSideBar/icons/ActivationIcon.vue
// module id = 652
// module chunks = 0